import { Outlet } from "react-router-dom";

const Forms = () => {
  return (
    <><Outlet /></>
  );
};

export default Forms;